function formatMoney(value, currency = 'BRL') {
  if (typeof value !== 'number') {
    return value;
  }

  const formatted = new Intl.NumberFormat('pt-br', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  });

  return formatted.format(value).replace('BRL', 'R$');
}

export default formatMoney;
